import React from 'react';
import { CnLayoutFooter as UICnLayoutFooter } from "../../components/cn-layout";
var CnLayoutFooter = function CnLayoutFooter(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutFooter, null, children);
};
CnLayoutFooter.displayName = 'CnLayoutFooter';
CnLayoutFooter.typeMark = 'Footer';
export default CnLayoutFooter;
export { CnLayoutFooter };